module.exports = __webpack_public_path__ + "static/media/23ca4e22-3d30-4b4e-b384-b1e0d8e0205d.ce535813.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/23ca4e22-3d30-4b4e-b384-b1e0d8e0205d.jpg
// module id = 806
// module chunks = 0